<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('announcements')">Announcement</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.id }}
    </h1>
    <trashed-message v-if="announcement.deleted_at" class="mb-6" @restore="restore">
      This announcement has been deleted.
    </trashed-message>
    <announcement-preview :preview_message=form.message />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <textarea-input v-model="form.message" class="pr-6 pb-8 w-full" label="Announcement Message" :error="this.$page.props.errors.message"/>
          <!--
            <text-input v-model="form.stream_title_hashtag" class="pr-6 pb-8 w-full lg:w-1/3" label="Stream Title Hashtags" rows="4" max-rows="6"/>
          <text-input v-model="form.stream_tags" class="pr-6 pb-8 w-full lg:w-1/3" label="Stream Tags" rows="4" max-rows="6"/>
          <text-input v-model="form.stream_game" class="pr-6 pb-8 w-full lg:w-1/3" label="Stream Game" />
          -->
          <select-input v-model="form.is_enabled" class="pr-6 pb-8 w-full lg:w-1/2" label="Is Enabled">
             <option value="1">Yes</option>
             <option value="0">No</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!announcement.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete announcement</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Announcement</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from '../../Shared/TextareaInput.vue'
import AnnouncementPreview from '@/Shared/AnnouncementPreview.vue'

export default {
  metaInfo() {
    return {
      title: `${this.form.message}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    TextareaInput,
    AnnouncementPreview,
  },
  layout: Layout,
  props: {
    announcement: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        id: this.announcement.id,
        message: this.announcement.message,
        stream_title_hashtag: this.announcement.stream_title_hashtag,
        stream_tags: this.announcement.stream_tags,
        stream_game: this.announcement.stream_game,
        is_enabled: this.announcement.is_enabled == true ? '1' : '0',
      })
    }
  },
  methods: {
    update() {
      this.form.put(this.route('announcements.update', this.announcement.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this announcement?')) {
        this.$inertia.delete(this.route('announcements.destroy', this.announcement.id))
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this announcement?')) {
        this.$inertia.put(this.route('announcements.restore', this.announcement.id))
      }
    },
  },
}
</script>
